var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.activityEnded)?_c('a',{class:_vm.$style.container,attrs:{"href":_vm.playbackUrl,"target":"_blank"}},[_c('font-awesome-icon',{directives:[{name:"tippy",rawName:"v-tippy"}],attrs:{"icon":_vm.faPlayCircle,"title":"Open"}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e726c04","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/CallInfo/PlayButton.vue
// module id = mWx7
// module chunks = 1